import * as actions from './extJira.actions';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector } from '@ngrx/store';
import { ExtJiraConfigModel } from '@smarttask-common/src/lib/models/Integrations/Jira/Config/ExtJiraConfigModel';

export const configAdapter = createEntityAdapter<ExtJiraConfigModel>({
    selectId: (x) => x.config_id,
});
export interface ExtJiraConfigState extends EntityState<ExtJiraConfigModel> {}

export const initialState: ExtJiraConfigState = configAdapter.getInitialState();

export function ExtJiraConfigReducers(state: ExtJiraConfigState = initialState, action: actions.ExtJiraConfigActions) {
    switch (action.type) {
        case actions.ExtJiraConfigActionTypes.UPSERT_EXT_JIRA_CONFIG:
            return configAdapter.upsertOne(action.config, state);

        case actions.ExtJiraConfigActionTypes.UPSERT_EXT_JIRA_CONFIGS:
            return configAdapter.upsertMany(action.configs, state);

        case actions.ExtJiraConfigActionTypes.DELETE_EXT_JIRA_CONFIG:
            return configAdapter.removeOne(action.config_id, state);

        case actions.ExtJiraConfigActionTypes.DELETE_EXT_JIRA_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        default:
            return state;
    }
}

export const getExtJiraConfigState = createFeatureSelector<ExtJiraConfigState>('extJiraConfig');

export const { selectAll } = configAdapter.getSelectors(getExtJiraConfigState);
